import { render, staticRenderFns } from "./VendorTermsOfService.vue?vue&type=template&id=fa62f456"
import script from "./VendorTermsOfService.vue?vue&type=script&lang=js"
export * from "./VendorTermsOfService.vue?vue&type=script&lang=js"
import style0 from "./VendorTermsOfService.vue?vue&type=style&index=0&id=fa62f456&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports